import Mitt from "mitt";

export const agentFinanceBus = Mitt();

export const AGENT_FINANCES_EVENTS = {
  REFRESH: "REFRESH",
};
